import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';


@Component({
  selector: 'app-construction-management',
  templateUrl: './construction-management.component.html',
  styleUrls: ['./construction-management.component.scss']
})
export class ConstructionManagementComponent implements OnInit {

  constructor(
    private router:Router,
    private titleService: Title
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle('MISK - Construction Management');
  }

}
